import { MathUtils } from "@/lib/main";
import { DonutChartFigCaptionPropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";
import { CSSProperties } from "react";
import DonutChartFigCaptionLine from "./DonutChartFigCaptionLine";

export default function DonutChartFigCaption({
  units,
  blueLabel,
  blueValue,
  yellowLabel,
  yellowValue,
  greenLabel,
  greenValue,
  redLabel,
  redValue,
  showPercentages,
}: DonutChartFigCaptionPropTypes) {
  const total = MathUtils.safeAdd(blueValue, yellowValue, greenValue, redValue);

  const legendListStyle: CSSProperties = {
    display: "grid",
    gridTemplateColumns: showPercentages
      ? "auto 1fr var(--spacing-md) auto auto"
      : "auto 1fr var(--spacing-md) auto",
    gap: "var(--spacing-sm)",
    alignItems: "center",
    justifyContent: "stretch",
    listStyle: "none",
    padding: 0,
    margin: 0,
  };

  return (
    <figcaption>
      <ul className="legend" style={legendListStyle}>
        {blueLabel && blueValue !== undefined && (
          <DonutChartFigCaptionLine
            units={units}
            label={blueLabel}
            value={blueValue}
            total={total}
            color="blue"
            showPercentages={showPercentages}
          />
        )}

        {yellowLabel && yellowValue !== undefined && (
          <DonutChartFigCaptionLine
            units={units}
            label={yellowLabel}
            value={yellowValue}
            total={total}
            color="yellow"
            showPercentages={showPercentages}
          />
        )}

        {greenLabel && greenValue !== undefined && (
          <DonutChartFigCaptionLine
            units={units}
            label={greenLabel}
            value={greenValue}
            total={total}
            color="green"
            showPercentages={showPercentages}
          />
        )}

        {redLabel && redValue !== undefined && (
          <DonutChartFigCaptionLine
            units={units}
            label={redLabel}
            value={redValue}
            total={total}
            color="red"
            showPercentages={showPercentages}
          />
        )}
      </ul>
    </figcaption>
  );
}
